import React from "react";
import { Navigate } from "react-router-dom";
const ProtectedRoutes = ({
  isAuth,
  redirectPath = "/",
  // redirectPath = "/mobile-number",
  children,
}) => {
  if (!isAuth) {
    return <Navigate to={redirectPath} state={{ showModal: true }} replace />;
  }
  return children;
};
export default ProtectedRoutes;
